var SwiperReviews = new Swiper(".content-slider-reviews", {
  direction: "vertical",
  slidesPerView: 3,
  spaceBetween: 10, // 👈 default para mobile (0 → 599px)
  effect: 'slide',
  speed: 900,
  loop: true,
   autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    600: {
      spaceBetween: 20, 
       slidesPerView: 4,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});
